import { render, staticRenderFns } from "./index.vue?vue&type=template&id=572a78ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./treatment-step-one.scss?vue&type=style&index=0&id=572a78ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a78ac",
  null
  
)

export default component.exports